import { Capacitor } from '@capacitor/core'

export const isPlatform = {
  android: () => {
    return Capacitor.getPlatform() === 'android'
  },
  ios: () => {
    return Capacitor.getPlatform() === 'ios'
  },
  capacitor: () => {
    return Capacitor.isNativePlatform()
  },
  web: () => {
    return Capacitor.getPlatform() === 'web'
  },
  mobile: () => {
    return isPlatform.android() || isPlatform.ios()
  }
} 